/* N1 · Galería de producto v5 (30/09/2026): evita el salto al cambiar de color y que los scrollIntoView de la galería muevan la página.
   - No sobreescribe window.scrollTo/scroll/scrollBy (v3 lo hacía y quitaba fluidez).
   - Cualquier scrollIntoView que el tema lance DENTRO de la galería se resuelve solo dentro del contenedor desplazable de la galería.
   - Durante 700 ms tras cambiar de variante se ignora del todo.
   - Fija la altura de la galería mientras se re-renderiza.
   (El diagnóstico ?n1diag=1 se retiró el 30/09/2026: identificó la causa del rebote en n1-pdp-mobile.js.) */
(function(){
 var lock=false,t=null;
 var eSIV=Element.prototype.scrollIntoView;
 function scroller(el,stop){var p=el.parentElement;while(p&&p!==stop&&p!==document.body){var cs=getComputedStyle(p);if(/(auto|scroll)/.test(cs.overflowX+cs.overflowY)&&(p.scrollWidth>p.clientWidth+1||p.scrollHeight>p.clientHeight+1))return p;p=p.parentElement}return null}
 function localScroll(el,g){var s=scroller(el,g);if(!s)return;var r=el.getBoundingClientRect(),c=s.getBoundingClientRect();
  if(r.left<c.left||r.right>c.right){var dx=(r.left+r.width/2)-(c.left+c.width/2);try{s.scrollBy({left:dx,behavior:'smooth'})}catch(e){s.scrollLeft+=dx}}
  if(r.top<c.top||r.bottom>c.bottom){var dy=(r.top+r.height/2)-(c.top+c.height/2);try{s.scrollBy({top:dy,behavior:'smooth'})}catch(e){s.scrollTop+=dy}}}
 Element.prototype.scrollIntoView=function(){
  var g=this.closest&&(this.closest('product-gallery')||this.closest('.product-gallery'));
  if(g){if(lock)return;localScroll(this,g);return}
  return eSIV.apply(this,arguments);
 };
 function arm(){
  lock=true;if(t)clearTimeout(t);t=setTimeout(function(){lock=false;t=null},700);
  var g=document.querySelector('.product-gallery');
  if(g&&g.offsetHeight&&!g.style.minHeight){g.style.minHeight=g.offsetHeight+'px';setTimeout(function(){g.style.minHeight=''},900)}
 }
 document.addEventListener('change',function(e){var el=e.target;if(el&&el.closest&&el.closest('.product-info .variant-picker'))arm()},true);
 document.addEventListener('variant:change',arm,true);
})();
